import locale from 'element-ui/lib/locale'

export default ({ app }) => {
  // instruct element-ui to use our vue-i18n instance for translations
  locale.i18n((key, value) => app.i18n.t(key, value))
  // look at /plugins/i18n to see how we merge their translations with ours
}
